import React, {useEffect, useState} from 'react';
import colors from '../../../../../util/colors';
import './styles.scss';
import {Column, Row} from '../../../../../components/layout';
import * as fonts from '../../../../../util/fonts';
import {strings} from '../../../../../util/strings';
import {connect} from 'react-redux';
import {compose} from 'redux';
import * as Yup from 'yup';
import {useHistory} from 'react-router-dom';
import {
  addToGlobalStyles,
  addToWizard,
  setWizard,
} from '../../../../../store/actions';
import {
  AppForm,
  AppFormDatePickerField,
  AppFormSelectField,
  AppFormSubmitButton,
} from '../../../../../components/forms';
import {
  get,
  postWithCustomHeaders,
  configsNoContentType,
} from '../../../../../api/api';
import {
  uriGetProcedures,
  uriMemberData,
  uriSubmitPreAuthorization,
} from '../../../../../api/endpoints';
import AppFilePreview from '../../../../../components/app-drap-drop-file-input/app-file-preview';
import {recreateFilesFromRedux, toDataUrl} from '../../../../../util/utility';
import AppSpinner from '../../../../../components/app-spinner';
import moment from 'moment';
import {
  IPreAuthorizationProcedure,
  IProcedureDetail,
} from '../../../PreAuthorizations';
import PopupList from '../../../../../components/popup-list';
import AppDragDropFileInput from '../../../../../components/app-drap-drop-file-input/AppDragDropFileInput';
import {ITenant} from '../../../../../App';

export interface DataValidationProps {
  onSubmit(values: any): any;
  setValid(value: boolean): void;
  valid: boolean;
  wizard: any;
  selectedBu: any;
  language: any;
  setWizard(value: any): void;
  addToWizard(value: any): void;
  addToGlobalStyles(value: any): void;
  labels: typeof strings.pt.createRefund;
  labels_auth: typeof strings.pt.preAuthorizations;
  messageLabels: typeof strings.pt.messages;
  buStyles: any;
  user: any;
  patients: any;
  documentTypes: any[];
  tenant: ITenant;
}

function DataValidation(props: DataValidationProps) {
  const {
    labels,
    wizard,
    labels_auth,
    buStyles,
    messageLabels,
    user,
    patients,
    language,
    documentTypes,
    tenant,
  } = props;

  const [sessionId, setSessionId] = useState<string>();
  const [patient, setPatient] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [patientOptions, setPatientOptions] = useState<any[]>([]);
  const [procedureOptions, setProcedureOptions] = useState<any[]>([]);
  const [formikContext, setFormikContext] = useState<any>();
  const [currentComment, setCurrentComment] = useState('');
  const history = useHistory();
  const [files, setFiles] = useState<any[]>([]);
  const [filesAdded, setFilesAdded] = useState<any[]>();
  const [showPopUpList, setShowPopUpList] = useState(false);
  const [errorMessage, setErrorMessage] = useState(
    labels_auth.authorization_occurredAnError,
  );
  const [errorPost, setErrorPost] = useState(false);

  const featureName = 'PreAuthorizations-DataValidation';
  const isServiaPortal = tenant?.country === 'RS';

  const validationSchema = Yup.object().shape({
    proceed: Yup.mixed().required(messageLabels.requiredField),
    currentDateOfOcurrence: Yup.date().required(messageLabels.requiredField),
  });

  if (!!wizard.attachFiles && !!!sessionId) {
    setSessionId(wizard.attachFiles.sessionId);
  }

  const onFileAdd = (addedFiles: any[]) => {
    setShowPopUpList(true);
    setFilesAdded(addedFiles);
  };

  // The message is obtained from the backend error response,
  // so if the error message changes there the string inside the includes method might need to be updated as well
  const getErrorFromMessage = (message: string) => {
    if (message.includes('File name too long')) {
      return labels_auth.authorization_tooManyCharactersError;
    }

    return labels_auth.authorization_occurredAnError;
  };

  const onDelete = (id: string) => {
    let newFiles = [...files];
    newFiles = newFiles.filter((elem) => {
      if (elem.id !== id) {
        return true;
      } else {
        URL.revokeObjectURL(elem.preview);
        return false;
      }
    });
    setFiles(newFiles);
  };

  const handleComment = (event: any) => {
    setCurrentComment(event.target.value);
  };

  function getPatientOptions() {
    const patients = props.patients.patients;

    setPatientOptions(
      (patients as any)?.map((patient: any) => ({
        value: patient.memId,
        label: patient.memberName,
      })),
    );
  }

  async function getProceedOptions() {
    const proceeds: any = await get(
      uriGetProcedures(props.selectedBu.buId),
      false,
      0,
      featureName,
    );

    const filteredProceeds = (proceeds?.data?.items as any[]).filter(
      (proceed) => {
        return proceed.status === 'ACTIVE';
      },
    );

    let proceduresAux: any = [];
    (filteredProceeds as any)?.forEach((item: IPreAuthorizationProcedure) => {
      const detail: IProcedureDetail | undefined =
        item.buPreAuthProcedureDetails.find(
          (det: IProcedureDetail) => det.languageAlias === language,
        );
      if (detail && detail.preAuthProcedureAlias && detail.frontendTitle) {
        proceduresAux.push({
          value: detail.serviceGroup,
          label: detail.frontendTitle,
        });
      }
    });

    setProcedureOptions(proceduresAux);
  }

  const setPreviousStepsData = () => {
    const {files: reduxFiles} = props.wizard.attachFiles;
    const newFiles = recreateFilesFromRedux(reduxFiles);
    const downloadBlobs =
      history.location && history.location.state && history.location.state;
    if (downloadBlobs) {
      newFiles.forEach((file: any) => {
        toDataUrl(file.preview, (base64: any) => {
          const files = [...newFiles];
          const newFile = {...file, preview: base64};
          files[files.indexOf(file)] = newFile;
          setFiles(files);
        });
      });
    } else {
      setFiles(newFiles);
    }
    getPatientOptions();
    setPatient(patients.memId);
    getProceedOptions();
  };

  const onSubmit = async (values: any, {validateForm}: any) => {
    const errors = await validateForm(values);
    if (Object.keys(errors).length > 0) {
      return;
    }

    setSubmitting(true);
    const {buId, famId, grpId, benNbr} = props.patients;
    const selectedContact: any = await get(
      uriMemberData(buId, patient, famId),
      false,
      0,
      featureName,
    );
    var formData = new FormData();
    props.addToWizard({
      attachFiles: {
        sessionId: sessionId,
        files: files,
      },
    });
    formData.append(
      'user',
      isServiaPortal ? user.given_name + ' ' + user.family_name : user.username,
    );
    formData.append('buId', selectedContact?.data?.buId);
    formData.append('memId', selectedContact?.data?.memId);
    formData.append('email', user.value.email);
    formData.append('beneficiary', benNbr);
    formData.append('phone', user.value.mobile);
    formData.append('name', selectedContact?.data?.name);
    formData.append('multicode', props.selectedBu.multicode);
    formData.append('usesMulticode', props.selectedBu.usesMulticode);
    formData.append('buName', props.selectedBu.buName);
    formData.append('procedure', values.proceed);
    formData.append(
      'procedureDate',
      moment(values.currentDateOfOcurrence).add(1, 'hours').format(),
    ); //acrescenta mais 1h para o dia não estar errado devido a timezone utc
    formData.append('comments', currentComment);
    files.forEach((doc) => {
      formData.append('documents', doc.file);
    });
    formData.append('groupId', grpId);

    try {
      const response: any = await postWithCustomHeaders(
        uriSubmitPreAuthorization(),
        formData,
        configsNoContentType(featureName),
      );
      if (response.result.status === 'Success') {
        const data = {
          patient: selectedContact?.data?.name,
          proceed: values.proceed,
          date: moment(values.currentDateOfOcurrence).add(1, 'hours').format(),
          submissionTime: moment().format('HH:mm'),
        };
        history.push('/pre-autorizacoes/pedido-enviado', data);
      } else {
        setErrorPost(true);
      }
    } catch (e: any) {
      const errorToShow = getErrorFromMessage(e?.data?.result?.message);

      setErrorMessage(errorToShow);
      setErrorPost(true);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    setPreviousStepsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wizard]);

  if (submitting) {
    return <AppSpinner />;
  }

  return (
    <div className="reimbersement-data-container">
      <AppForm
        className="patient-validation-form-container pre-authorization-container-form"
        initialValues={{
          currentDateOfOcurrence: '',
          noDocuments: false,
          proceed: '',
        }}
        validationSchema={validationSchema}
        onSubmit={async (values, {validateForm}) =>
          onSubmit(values, {validateForm})
        }>
        <Row className="reimbursement-confirm-data">
          <p
            style={{
              ...fonts.ML,
              ...fonts.Bold,
              color: colors.black,
            }}
            className="reimbursement-data-subtitle-desktop">
            {labels?.createRefund_confirmData}
          </p>
          <p
            style={{
              ...fonts.ML,
              ...fonts.Bold,
              color: colors.black,
            }}
            className="reimbursement-data-subtitle-responsive">
            {labels?.createRefund_confirmDataResponsive}
          </p>
        </Row>
        <div className="grid-container patient-row">
          <Column
            className="reimbursement-data-firstrow-column pre-authorization-column"
            style={{
              background: 'linear-gradient(180deg, #F9F9F9 0%, #F0F0F0 100%)',
            }}>
            <Row className="reimbursement-data-firstrow-column-firstrow">
              <p style={{...fonts.SM}}>{labels?.createRefund_patient}*</p>
            </Row>
            <Row>
              <AppFormSelectField
                showErrorMessage
                className="reimbursement-data-input w-100"
                name={'patient'}
                inputStyle={{
                  ...fonts.Bold,
                  color: buStyles?.primaryColor || colors.blue,
                }}
                options={patientOptions}
                value={patient}
                onChange={(value) => {
                  setPatient(value);
                }}
                handleFormikContext={(formik) => {
                  if (!!!formikContext) {
                    setFormikContext(formik);
                  }
                }}></AppFormSelectField>
            </Row>
          </Column>
          {files?.map((item: any) => (
            <Column
              className="reimbursement-data-firstrow-column reimbursement-data-file-preview pre-authorization-files pre-authorization-column"
              style={{
                background: 'linear-gradient(180deg, #F9F9F9 0%, #F0F0F0 100%)',
              }}>
              <div className="app-drag-drop-preview-responsive pre-authorization-preview">
                <AppFilePreview
                  displayQuantity={true}
                  name={item.name}
                  deleteAll
                  file={item}
                  files={[item]}
                  onDelete={() => onDelete(item.id)}
                  scope="preAuthorizations"
                />
              </div>
            </Column>
          ))}
        </div>
        <>
          <Row
            className="pre-authorization-data-row"
            style={{
              background: 'linear-gradient(180deg, #F9F9F9 0%, #F0F0F0 100%)',
            }}>
            <Column className="pre-authorization-data-row-left-column">
              <Column>
                <Row className="reimbursement-data-firstrow-column-firstrow">
                  <p style={{...fonts.SM}}>
                    {labels_auth.authorization_procedure}*
                  </p>
                </Row>
                <Row>
                  <AppFormSelectField
                    showErrorMessage
                    className="reimbursement-data-input-procedure w-100"
                    name={'proceed'}
                    options={procedureOptions}></AppFormSelectField>
                </Row>
              </Column>
              <Column>
                <Row className="reimbursement-data-firstrow-column-firstrow">
                  <p style={{...fonts.SM}}>
                    {labels_auth.authorization_procedureDate}*
                  </p>
                </Row>
                <Row className="date-picker-row">
                  <AppFormDatePickerField
                    showErrorMessage
                    className="reimbursement-data-input"
                    name={'currentDateOfOcurrence'}
                    placeholder={
                      labels_auth.authorization_procedureDatePlaceholder
                    }></AppFormDatePickerField>
                </Row>
              </Column>
            </Column>
            <Column className="pre-authorization-data-row-right-column">
              <Column>
                <Row className="reimbursement-data-firstrow-column-firstrow">
                  <p style={{...fonts.SM}}>
                    {labels_auth.authorization_comments}
                  </p>
                </Row>
                <Row>
                  <textarea
                    style={{...fonts.M}}
                    className="reimbursement-comments-notes-input"
                    name="commentsNotes"
                    placeholder={labels_auth.preAuthorizations_insertComments}
                    value={currentComment}
                    onChange={handleComment}></textarea>
                </Row>
              </Column>
            </Column>
          </Row>

          <Row className="upload-file-container">
            <AppDragDropFileInput
              preAuth={false}
              files={files}
              setFiles={setFiles}
              newFilesName={labels?.createRefund_invoice}
              onFileAdd={onFileAdd}
              filesSizeLimit={true}
              hidePreviews={true}
            />
          </Row>
        </>
        <Row className="pre-authorization-data-obligatory-fields">
          <p style={{...fonts.SM}}>
            {labels_auth.authorization_obligatoryFields}
          </p>
        </Row>
        <Row className="attach-files-confirm-button-row pre-authorization-button">
          <AppFormSubmitButton
            className="attach-files-confirm-button"
            title={labels_auth.authorization_send}
          />
        </Row>
        {errorPost && (
          <Row className="justify-content-center">
            <label style={{color: colors.alertRed}}>{errorMessage}</label>
          </Row>
        )}
      </AppForm>

      <PopupList
        onSubmit={(value) => {
          let newFiles = [...files];
          newFiles.forEach((item) => {
            let idAddedFile = filesAdded?.find((id) => item.id === id);
            if (idAddedFile) {
              item.name = value;
            }
            setShowPopUpList(false);
          });
          setFiles(newFiles);

          props.addToWizard({
            attachFiles: {
              sessionId: sessionId,
              files: newFiles,
            },
          });
        }}
        onClose={() => {
          const newFiles = files;
          newFiles.pop();
          setFiles(newFiles);
          setShowPopUpList(false);
        }}
        title={labels_auth?.preAuthorizations_documentType}
        show={showPopUpList}
        list={documentTypes}
        setShowModal={setShowPopUpList}
        titleOfButton={labels?.createRefund_confirm}
      />
    </div>
  );
}

const mapStateToProps = ({
  selectedBu,
  language,
  wizard,
  strings,
  globalStyles,
  user,
  patients,
  tenant,
}: any) => ({
  selectedBu: selectedBu.value,
  language: language.value,
  wizard: wizard.value,
  labels: strings.value.pt.createRefund,
  labels_auth: strings.value.pt.preAuthorizations,
  buStyles: globalStyles.value,
  messageLabels: strings.value.pt.messages,
  patients: patients.value,
  tenant: tenant.value,
  user,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(DataValidation),
);
